import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "default_collection",
  "use": "default_collection-usage",
  "viewBox": "0 0 20 20",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 20 20\" id=\"default_collection\"><g fill-rule=\"evenodd\"><path d=\"M2 7h16v10H2z\" opacity=\".12\" /><path d=\"M2 16h16v1H2z\" opacity=\".12\" /><path d=\"M1 16.5c0 .82.67 1.5 1.5 1.5h15c.83 0 1.5-.68 1.5-1.5v-11c0-.83-.67-1.5-1.5-1.5h-9l.35.15-2-2L6.7 2H2.5C1.67 2 1 2.67 1 3.5v13ZM18 7v10H2V7h16ZM6.5 3l-.35-.15 2 2L8.3 5h9.2c.28 0 .5.22.5.5V6H2V3.5c0-.28.22-.5.5-.5h4Z\" /></g></symbol>"
});
var result = sprite.add(symbol);
export default symbol